import Vue from "vue";

const icons = require.context("@/assets/svg/.", false, /\.svg$/);
icons.keys().forEach((fileName: string) => {
  const name = fileName?.split("/")?.pop()?.split(".");
  if (name && name?.length > 0) {
    Vue.component(`icon-${name[0]}`, icons(fileName));
  }
});
